// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'frontend_core/dist/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'

import { useAppLink } from 'hooks/useAppLink'
import { amplitudeLogEvent } from 'helpers/amplitude'

const Wrapper = styled.div`
  display: block;
  text-align: center;
  padding: 0 16px;
`

const Text = styled.p`
  font-weight: 600;
  font-size: ${fontSize.medium}px;
  line-height: 135%;
  text-align: center;
  color: ${Colors.mono.gray100};
  margin-bottom: ${spacing.medium}px;
`

const Button = styled.a`
  display: block;
  width: 100%;
  height: 48px;
  border-radius: 40px;
  border: 1px solid ${Colors.mono.gray100};
  background: ${Colors.mono.white};
  color: ${Colors.mono.gray100};
  padding: ${spacing.medium}px;
  text-align: center;
  text-decoration: none;
  font-weight: 600;
  font-size: ${fontSize.medium}px;
  line-height: 1;
  box-sizing: border-box;
`
const AppLinkSection = ({
  text = 'アプリならログインの手間いらず',
  eventName = 'Select App Install Button on Login',
  eventProperties = {},
  appLinkUrl,
}) => {
  const { appLinkHref, handleAppLinkClick } = useAppLink({ appLinkUrl })

  const handleClick = e => {
    amplitudeLogEvent(eventName, eventProperties)
    handleAppLinkClick(e)
  }

  return (
    <Wrapper>
      <Text>{text}</Text>
      <Button href={appLinkHref} onClick={handleClick}>
        アプリで開く
      </Button>
    </Wrapper>
  )
}
export default AppLinkSection
